import './GeneralPreferences.scss'

import { useCharacters } from '../../../contexts/Characters'
import { useToaster } from '../../../contexts/Toaster'
import { useUser } from '../../../contexts/User'
import { Roles } from '../../../utilities/constants'
import koalition from '../../../api/koalition'
import useFormBuilder from '../../../hooks/FormBuilderHook'
import Checkbox from '../../forms/Checkbox/Checkbox'
import DateTimePicker from '../../forms/DateTimePicker/DateTimePicker'

const GeneralPreferences = () => {
    const user = useUser()
    const toaster = useToaster()
    const generalPreferences = user.$state.preferences?.general || {}

    const updateUserGeneralPreferences = () => {
        const formValues = form.$state.value
        koalition.put('/users/preferences/general', formValues).then((response) => {
            user.save(response.data)
            toaster.success('Notification preferences updated successfully')
        }).catch((error) => {
            toaster.error(error)
            console.error(error)
        })
    }

    const form = useFormBuilder({ onSubmit: updateUserGeneralPreferences, controls: {
        allowMultipleLogins: { value: generalPreferences.allowMultipleLogins },
    }})
    
    return (
        <form className="col-12 general-preferences" onSubmit={form.$state.onSubmit}>
            <div className="row">
                <main className="col-12 mb-4">
                    <Checkbox control={form.$state.controls.allowMultipleLogins} label="Keep login across multiple devices" />
                </main>

                <footer className="col-12 text-right">
                    <button type="submit" className="primary large" disabled={form.$state.invalid}>Update</button>
                </footer>
            </div>
        </form>
    )
}

export default GeneralPreferences